; (function () {
    'use strict';

    angular
        .module('EMR.Admin')
        .service('EmrVersionUpdaterService', emrVersionUpdaterService);

    emrVersionUpdaterService.$inject = ['$http', '$rootScope', '$timeout', '$location', '$injector'];

    function emrVersionUpdaterService($http, $rootScope, $timeout, $location, $injector) {

        /**
         * @author Swaraj B
         * @since 07 Dec, 2022
         * from now onwards we are using a file(emr-version-tracker.json) 
         * which would be generated in gulp process to process version updates.
         * 
         * 
         * whole implementation logic for that is in this file.
         * 
         * we would check for that file changes, 
         * and trigger version update when any change has been detected.
         * 
         * the initialization and, version update handling part has been placed in., HomeController.js $onInit hook
         * 
         */

        let currentVersionNumber = 0;
        let versionCheckRetryCount = 0;
        let _isVersionUpdateAvailable = false;
        let isDevelopmentEnvironment = false;
        const VERSION_CHECK_MIN_INTERVAL = 180000;  // 3 minutes
        const VERSION_CHECK_MAX_INTERVAL = 480000;  // 8 minutes
        const emrVersioningFileUrl = `${getBaseUrl()}/emr-version-tracker.json`;
        var commonFactory = $injector.get('EMRCommonFactory');


        const service = {
            initializeVersionUpdateCheck: initializeVersionUpdateCheck,
            isVersionUpdateAvailable: isVersionUpdateAvailable,
            getVersionNumbertoLog
        };

        return service;

        function initializeVersionUpdateCheck() {
            //no need to check for version updates in development environment
            if (isDevelopmentEnvironment) return;
            getCurrentVersionNumber().then(function (versionNumber) {
                currentVersionNumber = versionNumber;
                if (window) {
                    window.emrVersionNumber = currentVersionNumber;
                }
                // if(commonFactory)
                //   commonFactory.EHRSaveAuditLogInformation(EHRAuditLogXperEMR_Components.Security, "EHR Web Version Number", `Version Number During Login ${currentVersionNumber}`, EHRAuditLogStatus.Success, EHRAuditLogActions.ADDITION, 0, EMRPracticeModel.LoggedUserID, undefined, undefined, true);
                //start checking version update from 3min, after the login
                checkForNewVersion();
            }, function (error) {
                console.error(error);
                //as we got an error while getting version number
                //we will retry to get the version number again after 5mins.
                $timeout(function () {
                    initializeVersionUpdateCheck();
                }, 300000);
            });
        }

        function checkForNewVersion() {
            $timeout(function () {
                getCurrentVersionNumber().then(function (versionNumber) {
                    if (versionNumber !== currentVersionNumber) {
                        _isVersionUpdateAvailable = true;
                        if (commonFactory)
                            commonFactory.EHRSaveAuditLogInformation(EHRAuditLogXperEMR_Components.Security, "EHR Web Version Number", `Version Number During Logout ${versionNumber}`, EHRAuditLogStatus.Success, EHRAuditLogActions.ADDITION, 0, EMRPracticeModel.LoggedUserID, undefined, undefined, true);
                        triggerVersionUpdate();
                    } else {
                        versionCheckRetryCount = 0;
                        //check for version change
                        // we would check for the version update every 3mins.
                        checkForNewVersion();
                    }
                }, function (error) {
                    console.error(error);
                    versionCheckRetryCount += 1;
                    if (versionCheckRetryCount > 10) {
                        if (commonFactory)
                            commonFactory.EHRSaveAuditLogInformation(EHRAuditLogXperEMR_Components.Security, "EHR Web Version Number", `Logging Out as Unable to get Verison Number for more than 3 times.`, EHRAuditLogStatus.Success, EHRAuditLogActions.ADDITION, 0, EMRPracticeModel.LoggedUserID, undefined, undefined, true);
                            //as we are unable to get version number consecutively for 3 times
                        triggerVersionUpdate();
                        //sendErrorMailOnVersionNumberGetFailure(error);
                        return;
                    }
                    checkForNewVersion();
                });
            }, getRandomInterval());
        }

        function getCurrentVersionNumber() {

            const timestamp = new Date().getTime();
            const randomPart = Math.floor(Math.random() * 1000000000000).toString();

            let mixed = randomPart.slice(0, 3) + (EMRPracticeModel.PracticeID || "") + randomPart.slice(3);

            mixed = mixed.slice(0, 9) + (EMRPracticeModel.LoggedUserID || "") + mixed.slice(9);

            const finalValue = mixed + timestamp;

            return $http.get(`${emrVersioningFileUrl}?v=${finalValue}`)
                .then(function (response) {
                    return response.data.version;
                });
        };
        function getRandomInterval() {
            return Math.floor(
                Math.random() * (VERSION_CHECK_MAX_INTERVAL - VERSION_CHECK_MIN_INTERVAL + 1)
            ) + VERSION_CHECK_MIN_INTERVAL;
        };


        function getBaseUrl() {
            const url = `${$location.protocol()}://${$location.host()}`;
            isDevelopmentEnvironment = url.indexOf('localhost') > -1;
            if (isDevelopmentEnvironment) {
                return `${url}/EMR_WEB_Base`;
            }
            return url;
        }

        function isVersionUpdateAvailable() {
            return _isVersionUpdateAvailable;
        }

        function triggerVersionUpdate() {
            $rootScope.$broadcast('emr.version.updated');
        }
        function getVersionNumbertoLog() {
            return currentVersionNumber;
        }
        // not tested because not calling this function
        function sendErrorMailOnVersionNumberGetFailure(error) {
            let GoogleCloudFunctionHandlerService = $injector.get('GoogleCloudFunctionHandlerService');
            const mailSubject = `Failed to Get Version Number`;
            const mailBody = getErrorMailBody(error);
           // const url = `${EMRPracticeModel.emrurlsmodel.EMRWebWCFPrimaryExternalURL}EHR_SendMailAPI/EHRMailController/SendAngularjsErrortoTechSupport`;
            const toMails = getMailIds();
            const requestBody = {
                mailSubject,
                mailBody,
                toMails
            };
            GoogleCloudFunctionHandlerService.post("EHR_SendAngularjsErrortoTechSupport_GCloudFunc", requestBody).then(function (response) {
                if (isError(response)) {
                    return;
                }
            });
        
            //$http.post(url, requestBody);
        }
        function getErrorMailBody(error = "") {
            var bodyHTML = `
            <html><body>
            <B>Practice Info       : </B><br />  <br />
            <B>Practice Name     : </B> ${EMRPracticeModel.PracticeName} <br>
            <B>Logged UserName   : </B> ${EMRPracticeModel.LoggedUserName}<br>
            <B>Practice ID     : </B> ${EMRPracticeModel.PracticeID}<br>
            <B>Logged User ID     : </B> ${EMRPracticeModel.LoggedUserID}<br>
            <B>Date & Time       : </B> ${adminGetCurrentDateAndTime() || new Date()}<br>
            <B>Version Number Request Url : </B> ${emrVersioningFileUrl}<br>
            <B>Version Number Get Failed reason : </B> ${typeof error === 'object' ? JSON.stringify(error) : error.toString()}<br>
            `

            return window.btoa(decodeURIComponent(encodeURIComponent(bodyHTML)));
        };
        function getMailIds() {
            if(EMRPracticeModel.PracticeID === 999) return;
            return [{
                Address: "uday.veeramachaneni@adaptamed.com",
            },
            {
                Address: "angularjserrors@adaptamed.org",
            },
            {
                Address: "venkatesh.polisetty@kjsystems.in",
            },
            {
                Address: "ramakrishna.maganti@adaptamed.com",
            },
            ]
        };
    }
})();